import api from '../axios';

export const get_plans = async () => {
  try {
    const response = await api.get('/plans');
    return response.data;
  } catch (error) {
    console.error('Error fetching plans:', error);
    return null;
  }
};

export const post_plan = async (data) => {
  try {
    const response = await api.post('/plans', data);
    return response.data;
  } catch (error) {
    console.error('Error creating plan:', error);
    return null;
  }
};

export const update_plan = async (data) => {
  try {
    const id = data._id || data.id;
    const response = await api.patch(`/plans/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating plan:', error);
    return null;
  }
};

export const delete_plan = async (data) => {
  try {
    const id = data._id || data.id;
    const response = await api.delete(`/plans/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting plan:', error);
    return null;
  }
};
